import { render, staticRenderFns } from "./insert-short-dialog.vue?vue&type=template&id=6fc73e36&scoped=true"
import script from "./insert-short-dialog.vue?vue&type=script&lang=js"
export * from "./insert-short-dialog.vue?vue&type=script&lang=js"
import style0 from "./insert-short-dialog.vue?vue&type=style&index=0&id=6fc73e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc73e36",
  null
  
)

export default component.exports